import { BRAND_ASSETS } from "@utils/logoAssets";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";

interface Props {
  className?: string;
  width?: number;
  height?: number;
  doNotLink?: boolean;
  withTitle?: boolean;
}

const Logo: FC<Props> = ({
  className,
  width = 50,
  height = 24,
  doNotLink,
  withTitle,
}) => {
  const hasSpecifiedSize = width && height;

  const ImageJSX = (
    <div
      className={
        hasSpecifiedSize
          ? className
          : classNames("flex w-11 md:w-[50px] h-6  ", className)
      }
      style={
        hasSpecifiedSize
          ? { width: `${width}px`, height: `${height}px` }
          : undefined
      }
    >
      <Image
        src={
          withTitle
            ? BRAND_ASSETS.logoWithVerticalTitle
            : BRAND_ASSETS.headerLogo
        }
        alt="فرادرس"
        width={width}
        height={height}
      />
    </div>
  );

  if (doNotLink) return ImageJSX;
  else
    return (
      <Link href="/" prefetch={false} aria-label="home">
        {ImageJSX}
      </Link>
    );
};

export default Logo;
